import { render, staticRenderFns } from "./DashboardHoldersTable.vue?vue&type=template&id=6e2d3a40&scoped=true"
import script from "./DashboardHoldersTable.vue?vue&type=script&lang=js"
export * from "./DashboardHoldersTable.vue?vue&type=script&lang=js"
import style0 from "./DashboardHoldersTable.vue?vue&type=style&index=0&id=6e2d3a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2d3a40",
  null
  
)

export default component.exports